import React from "react";
import { useTranslation } from "react-i18next";
import { SketchPicker } from "react-color";

import { templateActions } from "@pages/Applications/C&C/C&CSetup/templateStore";

import { ColorSvgIcon } from "@components/Common/SvgIcons";
import LanguageTable from "../../../Common/LanguageTable";
import { templateDefaultValue } from "@constants/template";
import BannerImages from "../../../Common/BannerImages";

export function Section3() {
    const { t } = useTranslation();
    const sketchPickerRef = React.useRef<HTMLDivElement>(null);

    const [color, setColor] = React.useState<any>(
        templateActions.getNestedObject([
            "template",
            "SiteWeb",
            "LaindingPage",
            "Section3",
            "Color",
        ]) !== null
            ? JSON.parse(
                  JSON.stringify(
                      templateActions.getNestedObject([
                          "template",
                          "SiteWeb",
                          "LaindingPage",
                          "Section3",
                          "Color",
                      ])
                  )
              )
            : "black"
    );
    const [colorMainPicker, setColorMainPicker] = React.useState(false);

    const handleChangeColor = () => {
        setColorMainPicker(!colorMainPicker);
    };
    const imagePath = React.useMemo(
        () => ["SiteWeb", "LaindingPage", "Section3", "Image"],
        []
    );

    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                sketchPickerRef.current &&
                !sketchPickerRef.current.contains(event.target as Node)
            ) {
                setColorMainPicker(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return (
        <div className="banner-container">
            <section className="text-section">
                <div className="banner-images" style={{ paddingRight: "20px" }}>
                    <BannerImages
                        dataPath={imagePath}
                        title="Image"
                        size="620*565 (png,jpg,jpeg ou webp)"
                    />
                </div>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <span
                        style={{ pointerEvents: "none", cursor: "default" }}
                        className="ml-3 mr-5"
                    >
                        {t("Main color")}
                    </span>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            paddingRight: "20px",
                        }}
                    >
                        <div
                            style={{
                                borderRadius: 3,
                                width: 160,
                                height: 20,
                                backgroundColor: color,
                                marginRight: 10,
                            }}
                        ></div>
                        <span
                            style={{
                                cursor: "pointer",
                            }}
                        >
                            <ColorSvgIcon
                                onClick={handleChangeColor}
                                height="20"
                                width="20"
                                color={color}
                            />
                            {colorMainPicker ? (
                                <div
                                    tabIndex={0}
                                    style={{
                                        position: "fixed",
                                        top: "30%",
                                        right: "67%",
                                        zIndex: 2,
                                    }}
                                    ref={sketchPickerRef}
                                >
                                    <SketchPicker
                                        color={color}
                                        onChange={(color) => {
                                            setColor(color.hex);
                                            templateActions.updateTemplate(
                                                [
                                                    "template",
                                                    "SiteWeb",
                                                    "LaindingPage",
                                                    "Section3",
                                                    "Color",
                                                ],
                                                color.hex
                                            );
                                        }}
                                    />
                                </div>
                            ) : null}
                        </span>
                    </div>
                </div>
                <LanguageTable
                    path={["SiteWeb", "LaindingPage", "Section3"]}
                    fields={[
                        {
                            key: "Title",
                            label: "Title",
                            placeholder: "Enter the Title",
                        },
                        {
                            key: "Description",
                            label: "Description",
                            placeholder: "Enter the Description",
                        },
                    ]}
                    defaultTexts={
                        templateDefaultValue.SiteWeb.LaindingPage.Section3
                    }
                    sectionTitle="Title and Description"
                />
            </section>
        </div>
    );
}
